module.exports = __webpack_public_path__ + "img/productivity-urls.67a15e10.png";